module.exports = __webpack_public_path__ + "static/media/01.ba8c9dc2.webp";